
// |--------------------------------------------------------------------------
// | DATA ANALYSER SETTINGS
// |--------------------------------------------------------------------------

export const barChartKeyNameMap = {
  emailViews: 'Email Views',
  emailReads: 'Email Reads',
  emailNewsletterViews: 'Email Views',
  emailNewsletterReads: 'Email Reads',
  webViews: 'Web Views',
  webDownloads: 'Downloads',
  sendgridOpened: 'Email Opens',
  sendgridClicked: 'Click Throughs',
}

export const readershipKeyNameMap = {
  emailReads: 'Email Reads',
  webViews: 'Web Views',
}

export const readershipSourceKeyMap = {
  emailReadCategory: 'emailReads',
  web: 'webViews',
}

export const bubblecloudBlacklists = {
  topic: [336, 349],
  geography: [29],
}

// Number of max items in top list
export const listTopK = 40

export const listTopInfinityK = 200
